import {Box, FormControl, Grid, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import {ChangeEvent, FC} from "react";
import {Sex} from '../../models/UserData';
import {useTranslation} from "react-i18next";


export type UserBasicData = {
  name: string|undefined,
  birthYear: number,
  sex: Sex|undefined
}
type Props = {
  userBasicData: UserBasicData
  onChange: (userBasicData: UserBasicData) => void,
  setError: (error: string | undefined) => void,
  error: string | undefined
}

export const UserDetailsForm: FC<Props> = ({userBasicData, onChange, setError, error}) => {
  const {t} = useTranslation();

  const handleBirthYearChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const birthYear = parseInt(e.target.value)
    if (e.target.validationMessage || isNaN(birthYear)) {
      setError(e.target.validationMessage ? e.target.validationMessage : t('user.wrongYear') || '')
    } else {
      setError(undefined)
    }
    onChange({...userBasicData, birthYear})
  }

  return (
    <>
        <Grid container spacing={2} justifyItems="center" justifyContent="center" alignItems="center" sx={{
          '& .MuiTextField-root': {m: 2,},
        }}>
          <Grid item xs={12} md={6}>
            <Box display="flex" justifyContent="center">
              <TextField
                error={!!error && !userBasicData.name}
                sx={{width: 300}}
                label={t('user.nameAndSurname')}
                id="event-name"
                value={userBasicData.name}
                onChange={(e) => onChange({...userBasicData, name: e.target.value})}
              />
            </Box>
          </Grid>
          <Grid item xs={5} md={3} display="flex" justifyContent="center">
            <TextField
              error={!!error && !userBasicData.birthYear}
              label={t('user.year')}
              id="birth-year"
              sx={{minWidth: 80}}
              value={userBasicData.birthYear}
              onChange={handleBirthYearChange}
              inputProps={{
                type: 'number',
                min: 1900,
                max: new Date().getFullYear(),
                step: 1,
                maxLength: 4,
              }}
            />
          </Grid>
          <Grid item xs={6} md={3} display="flex" justifyContent="center">
            <FormControl fullWidth>
              <InputLabel id="sex-label">{t('user.gender.label')}</InputLabel>
              <Select
                labelId="sex-label"
                error={!!error && !userBasicData.sex}
                id="user-sex"
                value={userBasicData.sex || null}
                onChange={(e) => onChange({...userBasicData, sex: (e.target.value as Sex)})}
              >
                <MenuItem value={Sex.MALE}>{t('user.gender.man')}</MenuItem>
                <MenuItem value={Sex.FEMALE}>{t('user.gender.woman')}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
    </>
  )
};